import { Helmet } from 'react-helmet-async';
import getCanonicalUrl from '../utils/canonical';

const TerminiServizio = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>Termini del Servizio | Officine del Cuore</title>
        <meta name="description" content="Termini e condizioni del servizio di Officine del Cuore. Leggi le nostre policy per un servizio trasparente e professionale." />
        <link rel="canonical" href={getCanonicalUrl('termini-servizio')} />
      </Helmet>

      <section className="section-elegant">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <h1 className="text-4xl font-playfair font-bold text-burgundy mb-8 text-center">
            Termini del Servizio
          </h1>

          <div className="prose-elegant space-y-6">
            <div className="bg-warm-white p-6 rounded-lg border-l-4 border-gold">
              <h2 className="text-xl font-semibold text-burgundy mb-3">Titolare</h2>
              <p className="mb-0">
                Officine del Cuore – P. IVA: 07950151212 - CCIAA Napoli n. REA NA- 927026 – email: info@officinedelcuore.it
              </p>
            </div>

            <p className="text-lg font-medium text-burgundy">
              L'accesso e l'utilizzo del presente sito web implicano l'accettazione dei seguenti Termini del Servizio.
            </p>

            <div className="space-y-6 mt-8">
              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">1. Oggetto del servizio</h3>
                <p>
                  Il sito ha finalità esclusivamente informative e di presentazione dei servizi offerti dall'agenzia matrimoniale Officine del Cuore. Non costituisce piattaforma di incontri online né garantisce risultati specifici in ambito relazionale.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">2. Servizi offerti</h3>
                <p>
                  L'agenzia fornisce servizi personalizzati di intermediazione relazionale, rivolti a persone maggiorenni. Le modalità, i costi e le condizioni dei servizi vengono definiti tramite contatto diretto e accordi separati.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">3. Requisiti degli utenti</h3>
                <p>
                  L'utente dichiara di essere maggiorenne e di fornire informazioni veritiere durante eventuali richieste di contatto o iscrizione.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">4. Limitazione di responsabilità</h3>
                <p>
                  L'agenzia non è responsabile per eventuali aspettative personali, decisioni o comportamenti degli utenti. I servizi offerti sono basati su valutazioni professionali ma non garantiscono esiti specifici. L'agenzia non è responsabile dei contenuti di eventuali siti esterni linkati. Il sito è a scopo informativo e il titolare non è responsabile per errori, omissioni o danni derivanti dall'uso delle informazioni contenute.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">5. Proprietà dei contenuti</h3>
                <p>
                  Tutti i contenuti presenti sul sito (testi, immagini, marchi) sono di proprietà dell'agenzia, coperti da Copyright e non possono essere copiati o utilizzati senza autorizzazione.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">6. Privacy</h3>
                <p>
                  I dati personali degli utenti sono trattati nel rispetto della normativa vigente, come indicato nella Privacy Policy.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">7. Modifiche</h3>
                <p>
                  L'agenzia si riserva il diritto di modificare i presenti Termini in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">8. Contatti</h3>
                <p>
                  Per informazioni è possibile contattare l'agenzia tramite i recapiti presenti sul sito.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-burgundy mb-3">9. Foro competente</h3>
                <p>
                  Il Foro di Napoli
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TerminiServizio;
